import type { DevModeSnippetExample } from '@cli-types/next-adapter/generators.js'
import { createExample } from './create-example.js'
export function createResponseExample(value: unknown): DevModeSnippetExample {
  return createExample('Response', value)
}
